<template>
  <div class="form-group" :class="{ 'has-error': hasErrors}">
    <label v-if="!['header', 'row', 'shared-form-preview', 'text-entry'].includes(field.type)"
           :for="field.name"
           class="control-label">
      <span v-if="required">* </span>
      {{ field.description }}
    </label>
    <component
      v-if="fieldComponent"
      ref="inputRef"
      :is="fieldComponent"
      :field="field"
      :required="required"
      :value="value"
      :locked="field.readOnly || locked"
      v-bind="$attrs"
      v-on="$listeners"
      @validate="validate"
    />
    <span v-if="hasErrors" class="help-block">
      {{ errorList[0].msg }}
    </span>
  </div>
</template>

<script>
import { computed, ref } from 'vue';

import RowRender from "./RowRender";
import DividerRender from "./DividerRender";
import SystemIdRender from "./SystemIdRender";
import HeaderRender from "./HeaderRender";
import SubheaderRender from "./SubheaderRender";
import NumberRender from "./NumberRender";
import TextRender from "./TextRender";
import TextareaRender from "./TextareaRender";
import CurrencyRender from "./CurrencyRender";
import AddressRender from "./AddressRender";
import CheckboxRender from "./CheckboxRender";
import CheckboxGroupRender from "./CheckboxGroupRender";
import RadioGroupRender from "./RadioGroupRender";
import DropdownRender from "./DropdownRender";
import RatingRender from "./RatingRender";
import TimeRender from "./TimeRender";
import FileRender from "./FileRender";
import ImageRender from "./ImageRender";
import SignatureRender from "./SignatureRender";
import CaseManagerRender from "./CaseManagerRender";
import DateRender from "./DateRender";
import SharedFormSummaryRender from "./SharedFormSummaryRender";
import ProgramCheckboxRender from "./ProgramCheckboxRender";
import DestinationAccountRender from "./DestinationAccountRender";
import PhoneRender from "./PhoneRender";
import SsnRender from "./SsnRender";

const COMPONENT_MAPPING = {
  'row': RowRender,
  'divider': DividerRender,
  'systemid': SystemIdRender,
  'header': HeaderRender,
  'text-entry': SubheaderRender,
  'number': NumberRender,
  'text': TextRender,
  'email': TextRender,
  'password': TextRender,
  'textarea': TextareaRender,
  'currency': CurrencyRender,
  'address': AddressRender,
  'phone': PhoneRender,
  'ssn': SsnRender,
  'checkbox': CheckboxRender,
  'checkbox-group': CheckboxGroupRender,
  'radio-group': RadioGroupRender,
  'select': DropdownRender,
  'rating': RatingRender,
  'time': TimeRender,
  'file': FileRender,
  'image-upload': ImageRender,
  'signature': SignatureRender,
  'select2': CaseManagerRender,
  'select_case_manager_secondary': CaseManagerRender,
  'date': DateRender,
  'shared-form-preview': SharedFormSummaryRender,
  'programs-checkbox-group': ProgramCheckboxRender,
  'destination-account': DestinationAccountRender,
}


export default {
  props: {
    value: {
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },

  setup(props) {
    let type;
    if (props.field.type === 'shared-field') {
      // XXX: field `values` are not available on the frontend for shared fields so we need to change type to text field
      if (['checkbox', 'checkbox-group', 'radio-group', 'select', 'rating'].includes(props.field.displayType)) {
        type = 'text';
      } else {
        type = props.field.displayType;
      }
    } else {
      type = props.field.type;
    }

    const fieldComponent = COMPONENT_MAPPING[type]

    const inputRef = ref()

    const errorList = computed(() => {
      if (inputRef.value) {
        return inputRef.value.errors.items.filter(i => i.field.includes(props.field.name))
      } else {
        return []
      }
    })
    const hasErrors = computed(() => errorList.value.length > 0)

    const validate = () => {
      return inputRef.value.$validator.validate()
    }

    return {
      fieldComponent,
      inputRef,
      hasErrors,
      errorList,
      validate
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldRenderWrapper.vue?935011a6